import {
  createCompanyMatcher,
  type MatchCompanyParams,
} from './company-tenant';

export const BASE_CONTROL_TOWER_CATEGORIES = [
  'VARIABLES',
  'STATION_STOPS',
  'STANDALONE_STATION_STOPS',
  'MACHINE_STOPS',
  'GATEWAY',
] as const;

export const FAULT_CODE_PROPAGATION_TOOLKIT_CATEGORY = 'FAULT_CODE_PROPAGATION_TOOLKIT' as const;

export type ControlTowerCategory =
  | (typeof BASE_CONTROL_TOWER_CATEGORIES)[number]
  | typeof FAULT_CODE_PROPAGATION_TOOLKIT_CATEGORY;

export const CONTROL_TOWER_FAULT_CODE_COMPANIES = [
  { subdomain: 'abi-app', name: 'Abinbev' },
  { subdomain: 'ccu-app', name: 'CCU' },
  { subdomain: 'altex-app', name: 'Altex' },
  { subdomain: 'bachoco-app', name: 'Bachoco' },
  { subdomain: 'bafar-app', name: 'Bafar' },
  { subdomain: 'jumex-app', name: 'Jumex' },
  { subdomain: 'cbc-app', name: 'CBC' },
  { subdomain: 'lacthosa-app', name: 'Lacthosa' },
] as const;

export type ControlTowerFaultCodeCompany =
  (typeof CONTROL_TOWER_FAULT_CODE_COMPANIES)[number];

export type BuildSupportedControlTowerCategoriesParams = MatchCompanyParams;

export const isControlTowerFaultCodeCompany = createCompanyMatcher(
  CONTROL_TOWER_FAULT_CODE_COMPANIES
);

export const buildSupportedControlTowerCategories = (
  params: BuildSupportedControlTowerCategoriesParams
): ControlTowerCategory[] => {
  if (isControlTowerFaultCodeCompany(params)) {
    return [...BASE_CONTROL_TOWER_CATEGORIES, FAULT_CODE_PROPAGATION_TOOLKIT_CATEGORY];
  }

  return [...BASE_CONTROL_TOWER_CATEGORIES];
};

export const buildSupportedControlTowerCategoriesFilter = (
  params: BuildSupportedControlTowerCategoriesParams
): string => `category=${buildSupportedControlTowerCategories(params).join(',')}`;

export const buildActivePriorityGroupsFilters = (
  params: BuildSupportedControlTowerCategoriesParams
): string => `state=ACTIVE;${buildSupportedControlTowerCategoriesFilter(params)}`;
